import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "5 crazy ideas that make $1,000/month",
  "description": "",
  "published": "2020-01-17T00:00:00.000Z",
  "redirect_from": ["/blog/5-crazy-ideas-that-make-1000-month/swizec/9287"],
  "categories": "Business, Side Projects",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`We're talking about making an extra $1000 a month this week, my friend. So today I wanted to share 5 crazy ideas that make $1,000/month.`}</p>
    <p>{`These are real businesses built by people like you. Engineers hacking on the side, solving real problems too small for big startups to chase. Shared by some of my internet friends`}</p>
    <p>{`lets go`}</p>
    <h2 {...{
      "id": "css-scan"
    }}>{`CSS Scan`}</h2>
    <p>{`Guilherme Rizzo built `}<a parentName="p" {...{
        "href": "https://getcssscan.com/"
      }}>{`CSS Scan`}</a>{` because he`}</p>
    <blockquote>
      <p parentName="blockquote">{`always wanted to know what border-radius, box-shadow or font-family an element I see has. So, inspired by WhatFont? I decided to create a tool that wherever you point your mouse over, you get the computed CSS of the element. That was the initial idea.`}</p>
    </blockquote>
    <p>{`It solves a problem we all have and are too lazy to fix.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you always catch yourself using Inspect Element to understand the CSS of some website you're seeing, this is like a Goodbye to "Inspect Element". You can check the CSS of any element you hover over, instantly, and copy its entire rules with a single click. It's the fastest and easiest way to check, copy and edit CSS`}</p>
    </blockquote>
    <p>{`😍`}</p>
    <p>{`He's been averaging $1,000/month in sales, mostly from twitter followers, building an audience, and reaching out to CSS influencers.`}</p>
    <p>{`I didn't even know there were CSS influencers.​.`}</p>
    <h2 {...{
      "id": "doka"
    }}>{`Doka`}</h2>
    <p><a parentName="p" {...{
        "href": "https://pqina.nl/doka/"
      }}>{`Doka`}</a>{` boggles the mind. It's a `}<em parentName="p">{`javascript library`}</em>{` making almost $6,000/month, which is more than 1k. But damn! A LIBRARY.`}</p>
    <p>{`Rik Schennink built Doka to solve this problem: A good image editor in the browser.`}</p>
    <blockquote>
      <p parentName="blockquote">{`I was trying to find a JavaScript image editor, IMHO they just weren't good enough, so I decided to build one myself. Doka makes image editing easy for both the user and the developer. The UX feels native and the product can be integrated by a developer in just a couple minutes. Most of my customers find Doka via FilePond (MIT licensed file upload component), it's quite popular so it sends traffic to Doka.`}</p>
    </blockquote>
    <h2 {...{
      "id": "solid-book"
    }}>{`Solid Book`}</h2>
    <p>{`Khalil Stemmler is writing `}<a parentName="p" {...{
        "href": "https://solidbook.io/"
      }}>{`Solid Book`}</a>{` to teach developers how to write testable, flexible, and maintainable code with Node.js and TypeScript.`}</p>
    <blockquote>
      <p parentName="blockquote">{`I got the idea to work on this book after having spent over $800 on software books in order to learn how to fix a terrible codebase (that only I myself could blame for having designed). It made me realize that not a lot has changed about software in the past 40 years, but all those teachings have been spread out across several books. I wanted to create an introductory resource for junior to mid-level developers to mimimize their unknown unknowns about software design & architecture.`}</p>
    </blockquote>
    <p>{`He's totally right. Fundamentals haven't changed and yet here we are, rediscovering it all every day :)`}</p>
    <p>{`So Khalil built a serverless JAMStack site for the book, added a buy button, and now Google and his blog are bringing enough traffic to make almost $2k/month.`}</p>
    <p>{`You go Khalil 💪`}</p>
    <h2 {...{
      "id": "jons-productized-consulting"
    }}>{`Jon's productized consulting`}</h2>
    <p>{`Productized consulting is a half-step between selling your time and selling a product. It's a great step towards freedom.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/jonmajorc"
      }}>{`Jon Major Condon`}</a>{` is using this approach to make money mentoring very junior students on the basics of React. You know, the sort of stuff he's forgotten he's learned.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Each year I do a lot of software related mentoring. Recently I’ve adventured into paid mentorship. I am working with a company remotely helping their student developers get up to speed in React. I do code reviews for the company, but I do a little amount of coding with this client. Recently, my more in depth coding project has been building a site for a small business in Ruby on Rails; that small business is a service providing the community a wide variety of sporting tournaments. My other client right now has been using my newly found passion for photography to take marketing photos of their CrossFit gym. After their website is done, I have the pleasure of starting on a promotion video for them — hence the filmmaking reference above!`}</p>
      <p parentName="blockquote">{`Although I am split into multiple channels, I’ve found opportunities to make money in each channel. I’ve found my passion for learning and growing has really been the driving factor into me starting my side hustle.`}</p>
    </blockquote>
    <p>{`A great example of someone who's just starting to business seriously. You can see a lot of this same approach in my own writings from a few years ago.`}</p>
    <p>{`Point is, `}<strong parentName="p">{`you`}</strong>{` can get started right now, my friend.`}</p>
    <h2 {...{
      "id": "burner-mail"
    }}>{`Burner Mail`}</h2>
    <p>{`Sergiu Calborean built `}<a parentName="p" {...{
        "href": "https://burnermail.io/"
      }}>{`Burner Mail`}</a>{` to solve the email privacy problem. How do you sign up for fun things online without getting a bunch of spam later?`}</p>
    <blockquote>
      <p parentName="blockquote">{`We decided to create Burner Mail out of our own frustration with being spammed and being targets for scammers. Burner Mail is a tool for generating burner email addresses. Instead of giving your personal email address, Burner Mail generates a unique and anonymous email for every service you sign up with, making it really hard for companies and advertisers to track you online. The burner addresses forward all emails to your personal inbox, collecting zero personal information. Unlike other disposable and throw away email services, Burner Mail’s email addresses do not expire and are meant to be used long term to protect your personal email address from spam, scams, data breaches, and identity theft.`}</p>
    </blockquote>
    <p>{`Yeah I know some folks use those to sign up for my stuff. I see you 😘`}</p>
    <p>{`Sergiu didn't share a back story behind Burner Mail, but he did mention they're making about $1400/month right now. Good job 👏`}</p>
    <h2 {...{
      "id": "tin-mustard"
    }}>{`Tin Mustard`}</h2>
    <p>{`A mysterious twitter follower shared just this link 👉 `}<a parentName="p" {...{
        "href": "https://tinmustard.com/"
      }}>{`Tin Mustard`}</a>{`. Named after himself it's an artisanal mustard that sells $1,000/month.`}</p>
    <p>{`Mustard. Online. $1,000.`}</p>
    <p>{`The internet truly is a magical place.`}</p>
    <p>{`So, my friend, what are you gonna create​? hit reply, next week we'll talk about how`}</p>
    <p>{`Happy Friday`}</p>
    <p>{`~Swizec`}</p>
    <p>{`PS: to share an example of my own, the react dataviz course generates about $1600/month from a tiny problem: Using React and D3 together is confusing.`}</p>
    <p>{`Tiny problems are best. You got dis.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      